import axios from "axios";
import { environment } from "@environments/environment";

export async function uploadFileToS3(file: File, uploadUrl: string) {
  try {
    const blob = new Blob([file], { type: file.type });
    const response = await axios.put(uploadUrl, blob, {
      headers: {
        "Content-Type": file.type, // Use the actual file type
        "Content-Length": file.size.toString(),
      },
      timeout: 60000,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });

    return response;
  } catch (error) {
    console.error("Upload failed:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function uploadStudentFile(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/exam-submissions/upload-document`,
      body
    );
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to upload data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export const createAnswersheetSubmission = async (body: any) => {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/exam-submissions/create`,
      body
    );
    if (response?.data) {
      return response?.data || {};
    }
  } catch (error) {
    console.error("Error creating answersheet submission:", error);
    let errorMessage = "Error creating answersheet submission";
    if (axios.isAxiosError(error) && error.response?.data?.detail) {
      errorMessage = error.response.data.detail;
    } else if (error instanceof Error) {
      errorMessage += ": " + error.message;
    } else {
      errorMessage += ": " + String(error);
    }
    throw new Error(errorMessage);
  }
};

export async function createBulkUpload(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/exam-submissions/bulk-create`,
      body
    );
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to upload data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function getAnswersheetUploadURL(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/exam-submissions/get-upload-url`,
      body
    );
    if (response && response?.status == 200) {
      return response.data || {};
    } else {
      throw new Error("Failed to upload file");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    throw new Error(
      "Error uploading file: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function getExamSubmissionIdByExamId(
  examSessionId: string | null,
  cursor: string | null,
  limit: number
) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    let url = `api/v1/exam-submissions/exam-session/${examSessionId}?limit=${limit}`;
    if (cursor) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }
    const response = await apiInstance.get(url);
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to upload data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
